package de.oevbs.kunde.kundenportal2.services.registration

import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kosmos.ui.forms.inputgroup.inputText
import de.oevbs.kosmos.ui.icons.MaterialIconsOutlined
import de.oevbs.kunde.kundenportal2.*
import de.oevbs.kunde.kundenportal2.components.*
import de.oevbs.kunde.kundenportal2.model.services.registration.*
import de.oevbs.kunde.kundenportal2.navigation.visit
import de.oevbs.kunde.kundenportal2.services.registration.store.ResetStore
import dev.fritz2.core.RenderContext
import dev.fritz2.core.invoke
import dev.fritz2.headless.validation.Severity
import kotlinx.coroutines.flow.combine

fun RenderContext.resetStart() {
    val resetStore = ResetStore(job)
    GlobalServiceMessagesStore.forceClear()

    headerImageLayout {
        title("Eine Passwort-Änderung anfordern")
        content {
            renderReset(resetStore)
        }
    }
}

fun RenderContext.resetContinue() {
    val resetStore = ResetStore(job)
    resetStore.setStep(ResetStep.PASSWORD3)

    headerImageLayout {
        title("Ihr neues Passwort")
        content {
            renderReset(resetStore)
        }
    }
}

private fun RenderContext.renderReset(resetStore: ResetStore) {

    div("sm:w-full xl:w-3/4") { // Angaben werden nur für die schmalen Seiten vor dem Login genutzt
        contentContainer {

            resetStore.currentStep.combine(theRouter.data, ::Pair).render { (step, paramsMap) ->

                when (step) {

                    // Schritt 1, Link an Usereingabe schicken
                    ResetStep.USERINPUT1 -> resetPasswordInputUser(resetStore)

                    // Schritt 2, Link erfolgreich verschickt
                    ResetStep.USERSUCCESS2 -> {
                        messagePageText(
                            header = "Mail für Passwort-Änderung wurde versendet.",
                            text = "Wir haben eine Mail an die mit Ihrem Account verknüpfte Adresse verschickt."
                                    + " Bitte klicken Sie den Link in der Mail, um mit der Passwort-Änderung fortzufahren."
                                    + " Sie können dieses Fenster jetzt schließen."
                        )
                    }

                    // Schritt 3, Link in der Mail wurde geclickt
                    ResetStep.PASSWORD3 -> {

                        //https://entw.kunde.oeffentliche.de/index.html#page=resetcontinue&token=8mYCBhzQcZANk1JBuajMSSm6wZMCP7YykFVGQbsqQQTzczLeZf


                        val invalidParam = paramsMap["invalid"]
                        if (invalidParam != null) { // Link ist abgelaufen - Fehler anzeigen und Prozess neu beginnen
                            GlobalServiceMessagesStore.add(PortalMessages.tokenInvalid)
                            Pages.reset.visit()
                        }

                        val tokenParam = paramsMap["token"]
                        // Token wurde als URL-Param übergeben: ?token=yyy
                        if (tokenParam != null) {
                            val tokenSub = resetStore.map(Reset.token() + Formats.trimString)
                            tokenSub.update(tokenParam)
                            resetPasswordInputPass(resetStore)
                        } else {
                            messagePageText(
                                header = "Fehler: Seite ungültig",
                                text = "Die Seite wurde mit ungültigen Parametern aufgerufen. Bitte starten Sie den Prozess erneut.",
                                severity = Severity.Error
                            )
                        }
                    }

                    // Schritt 4, Pass wurde geändert
                    ResetStep.PASSSUCCESS4 -> {
                        messagePageText(
                            header = "Passwort-Änderung erfolgreich",
                            text = "Ihr neues Passwort wurde aktiviert. Sie können sich nun wieder ins Kundenportal einloggen.",
                            buttonLabel = "Weiter zum Login",
                            pageTarget = Pages.root
                        )
                    }

                    else -> {
                        console.error("Unbekannter ResetStep: '${step}'. Zeige Step 1 an.")
                        resetPasswordInputUser(resetStore)
                    }
                }
            }
        }
    }
}

private fun RenderContext.resetPasswordInputUser(resetStore: ResetStore) {

    paragraph {
        +"Um ein neues Passwort für Ihren Account bei "
        b { +"Meine Öffentliche" }
        +" zu erhalten, geben Sie bitte Ihren Benutzernamen ein. Diesen finden Sie in der Willkommens-Mail, die Sie"
        +" im Anschluss an die "
        textualButton("Registrierung") handledBy { Pages.registration.visit() }
        +" erhalten haben."
        +" Sollten Sie bereits Versicherungsverträge mit Ihrem Account verknüpft haben, können Sie alternativ Ihre Partnernummer angeben."
    }

    inputText {
        value(resetStore.map(Reset.userOrPartner() + Formats.partnerId))
        label("Benutzername oder Partnernummer")
        iconClickableWithPopover(MaterialIconsOutlined.help, HelpPopovers.resetPassUserOrPartner)
    }

    buttonContainer {
        btn {
            label("Passwort-Anfrage abschicken")
            busy(globalSubmitTracker.data)
        }.clicks handledBy resetStore.handleUserOrPartner

        btn {
            label("Benutzername vergessen?")
        }.clicks handledBy { Pages.retrieveUser.visit() }
    }
}

private fun RenderContext.resetPasswordInputPass(resetStore: ResetStore) {

    paragraph {
        +"Wählen Sie ein neues Passwort für Ihren Account und wiederholen Sie die Eingabe im zweiten Feld. Anschließend können Sie"
        +" Ihr neues Passwort aktivieren und sich wieder ins Kundenportal einloggen."
    }

    inputPassword {
        value(resetStore.map(Reset.newPassword() + Formats.trimString))
        label("Neues Passwort")
        iconClickableWithPopover(MaterialIconsOutlined.help, HelpPopovers.password)
    }

    inputPassword {
        value(resetStore.map(Reset.newPasswordRepeat() + Formats.trimString))
        label("Neues Passwort wiederholen")
    }

    buttonContainer {
        btn {
            label("Neues Passwort aktivieren")
            busy(globalSubmitTracker.data)
        }.clicks handledBy resetStore.handleNewPass
    }
}